<div class="review-warning-container">
    <div class="warning-container-body">
        <p>{{alertvarservice.already_using_msg}}</p>
        <p class="last-review-info">{{alertvarservice.titles.templateTitles.force_continue.user}} <span class="username-text">{{data.user_already_review}}</span> {{alertvarservice.titles.templateTitles.force_continue.last_reviewed_at}} <span class="last-review-time">{{data.lattest_time}}</span></p>

    </div>
    <div class="warning-container-bottom">
        <button class="submit" mat-dialog-close (click)="terminate_session_alert()" >{{alertvarservice.titles.templateTitles.force_continue.yes}}</button>
        <button class="cancel" mat-dialog-close (click)="cancel()" >{{alertvarservice.titles.templateTitles.force_continue.no}}</button>
    </div>
</div>

